<cam-badge [value]="this.label() | translate" [type]="this.badgeType()"></cam-badge>
